import React from 'react';
import PropTypes from 'prop-types';

const checkboxWrapperClasses = 'tw-relative tw-flex tw-pl-8';
const radioWrapperClasses = 'tw-flex tw-items-center tw-gap-4';
const checkboxClasses =
    'tw-absolute tw-left-0 tw-top-0.5 tw-border tw-border-solid tw-border-darkBlue tw-accent-darkBlue dark:tw-border-neonYellow dark:tw-bg-veryBlack dark:tw-accent-neonYellow dark:checked:tw-border-neonYellow dark:checked:tw-bg-veryBlack dark:checked:hover:tw-border-white dark:checked:hover:tw-bg-veryBlack dark:focus:tw-ring-0 dark:checked:focus:tw-bg-veryBlack';
const radioClasses =
    'tw-border tw-border-solid tw-border-darkBlue tw-accent-darkBlue dark:tw-border-neonYellow dark:tw-bg-veryBlack dark:tw-accent-neonYellow dark:checked:tw-border-neonYellow dark:checked:tw-bg-veryBlack dark:checked:hover:tw-border-neonYellow dark:checked:hover:tw-bg-veryBlack dark:focus:tw-ring-0 dark:checked:focus:tw-bg-veryBlack';

export const FormInput = ({label, type, name, value, onChange, checked = null}) => {
    return (
        <div className={type === 'checkbox' ? checkboxWrapperClasses : radioWrapperClasses}>
            <input
                type={type}
                className={type === 'checkbox' ? checkboxClasses : radioClasses}
                id={`${value}-${name}`}
                name={name}
                value={value}
                onChange={onChange}
                checked={checked}
            />
            <label htmlFor={`${value}-${name}`}>{label}</label>
        </div>
    );
};

FormInput.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
};
